import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { cancellationFeePreview } from './queryKeys';
import envVars from '../../../constants/envVars';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
const useGetCancellationFeePreview = (props, enabled) => {
    const additional = useQueryRequestParams();
    const id = props.id || props.hero_user_id || props.device_serial;
    return useQuery({
        queryFn: () => axios.get(`${envVars.API_COMMERCE_HOSTNAME}subscription/backoffice/cancellation-fee-preview`, {
            ...additional,
            params: { ...props }
        }),
        queryKey: [cancellationFeePreview, id],
        enabled
    });
};
export default useGetCancellationFeePreview;
